<template>
  <div class="lego-accordion">
    <slot>
      <lego-accordion-item
        v-for="(item, index) in items"
        v-model="value[index]"
        :title="item.title"
        :key="index"
        :width="width"
        :check="check"
        :readonly="item.readonly"
        :expandable="expandable"
        ref="accordionItem"
        @toggle="val => checkToggle(val, index)"
      >
        <template #title>
          <slot name="title" :item="item">{{ item.title }}</slot>
        </template>
        <template #expand>
          <slot name="expand" :item="item"></slot>
        </template>
      </lego-accordion-item>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'legoAccordion',
  props: {
    expandable: {type: Boolean, default: false},
    value: {
      type: Array,
      default: () => [],
    },
    // radio: { type: Boolean, default: undefined }, //TODO: radio 그룹 기능 추가
    check: { type: Boolean, default: undefined },
    items: {
      type: Array,
      default: () => [],
    },
    width: {
      type: Number,
      default: null,
    },
    autoCollapse: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    checkToggle(val, checkIndex) {
      if (this.autoCollapse) {
        this.items.forEach((item, itemIdx) => {
          if (checkIndex !== itemIdx) {
            this.$refs.accordionItem[itemIdx].clearExpand();
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
